export enum BloodTypes {
    A_POSITIVE = 1,
    A_NEGATIVE = 2,
    B_POSITIVE = 3,
    B_NEGATIVE = 4,
    AB_POSITIVE = 5,
    AB_NEGATIVE = 6,
    O_POSITIVE = 7,
    O_NEGATIVE = 8
}

export const BloodTypesLabels: Record<BloodTypes, string> = {
    [BloodTypes.A_POSITIVE]: 'A+',
    [BloodTypes.A_NEGATIVE]: 'A-',
    [BloodTypes.B_POSITIVE]: 'B+',
    [BloodTypes.B_NEGATIVE]: 'B-',
    [BloodTypes.AB_POSITIVE]: 'AB+',
    [BloodTypes.AB_NEGATIVE]: 'AB-',
    [BloodTypes.O_POSITIVE]: 'O+',
    [BloodTypes.O_NEGATIVE]: 'O-'
}
